import { Navigate, useParams } from 'react-router-dom';

// Legacy redirect: /staff/tournaments/:eventId -> /staff/events/:eventId
const StaffTournamentsRedirect = () => {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/staff/events/${eventId}`} replace />;
};

export default StaffTournamentsRedirect;
